export default __webpack_public_path__ + "static/speedmeter-a44b173b1a568be9a355a45bd66a7089.png";